
<template>
  <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
      <span>{{name}}</span>
    </div>
    <div class="text item paramContainer"> 
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="8">
            Finish task
        </el-col>
        <el-col :span="16">
            <el-input-number maxlength="99" minlengt="0" :step="1" size="mini" v-model="model.params.finish_task_percentage"></el-input-number>    
        </el-col>
      </el-row>  
      
      <div class="tip">
          {{desc}}
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'EndOfTask',
  data () {
    return {
      name: 'End of task',
      desc: '',
    }
  }, 
  props: {
      model: {
          type: Object,
          default: () => {}
      },
  },
  methods: {
   
  },
  computed: {
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading',
    }),
  },
}
</script>

<style lang="scss" scoped>

</style>
